export enum ModeType {
  DAY = 'day',
  HOUR = 'hour',
  WEEK = 'week',
}

export const ModeTypeSetObj: any = {
  [ModeType.DAY]: {
    timePeriod: 24 * 60,
    maxDay: 182,
    exceedText: '因数据过大，日维度仅可展示开始日期后半年内数据',
  },
  [ModeType.HOUR]: {
    timePeriod: 60,
    maxDay: 14,
    exceedText: '因数据过大，时维度仅可展示开始日期后两周内数据'
  },
  [ModeType.WEEK]: {
    timePeriod: 24 * 60 * 7,
    maxWeek: 52,
    exceedText: '因数据过大，周维度仅可展示开始日期后一年内数据'
  },
}

export const DEFAULT_DAY = 60


export const MIN_WIDTH = 10;

export const COL_WIDTH = 72;

export const getBgColor = (type?: any, isHover?: boolean) => {
  switch (type) {
    case 0:
      return isHover ? '#8AB1FF' : '#D6E4FF';
    case 1:
      return isHover ? '#FFB17F' : '#FFE0CC';
    default:
      break;
  }
};

export const borderColorObj = {
  0: 'rgba(47, 84, 235, 1)',
  1: 'rgba(214, 228, 255, 1)',
}
